import { RECENT_RESULTS, PERFORMANCE } from "@/lib/content";
import { Trophy, TrendingUp } from "lucide-react";
import ResponsibleBanner from "@/components/ResponsibleBanner";

export default function LeaderboardPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-14 space-y-10">
      <div>
        <div className="text-xs font-bold tracking-[0.2em] text-smasher-orange mb-1">TRACK RECORD</div>
        <h1 className="font-heading font-black uppercase text-4xl sm:text-5xl text-gradient-gold flex items-center gap-3"><Trophy className="w-9 h-9 text-smasher-gold" /> Leaderboard</h1>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {[["WIN STREAK", `${PERFORMANCE.winStreak} days`], ["THIS WEEK", PERFORMANCE.thisWeek], ["THIS MONTH", PERFORMANCE.thisMonth], ["ALL TIME", PERFORMANCE.allTime]].map(([k, v]) => (
          <div key={k} className="panel p-5 text-center">
            <div className="text-[10px] text-slate-500 tracking-wide">{k}</div>
            <div className="font-heading font-black text-2xl text-emerald-400 mt-1">{v}</div>
          </div>
        ))}
      </div>

      <div className="panel p-5">
        <div className="flex items-center gap-2 font-heading font-bold tracking-wide text-smasher-gold mb-4"><TrendingUp className="w-5 h-5" /> RECENT RESULTS</div>
        <div className="space-y-1">
          {RECENT_RESULTS.map((r, i) => (
            <div key={i} className="flex items-center gap-3 py-2.5 border-b border-white/5 last:border-0 text-sm">
              <span className="text-slate-500 font-mono-num w-12">{r.date}</span>
              <span className="text-smasher-gold font-bold w-16">{r.league}</span>
              <span className="text-slate-200 flex-1">{r.pick}</span>
              <span className="text-emerald-400 font-bold">{r.result}</span>
              <span className="text-emerald-400 font-mono-num">{r.units}</span>
            </div>
          ))}
        </div>
      </div>

      <p className="text-xs text-slate-600 text-center">Performance figures are illustrative. Past results do not guarantee future outcomes.</p>
      <ResponsibleBanner />
    </div>
  );
}
